import { UatDataset } from './types/uat-dataset.interface'
import uatFile from './uat.json'

export const uatId = (id: string): UatDataset => ({
  'data-uat-id': (uatFile as Record<string, string>)[id]
})
